
export const  scrollTo = position => window.scrollTo({ 
    top : position,
    behavior : 'smooth' ,
})